import React, { useState, useEffect } from 'react';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import AppstoreIcon from '@/pages/intelligence/assets/svg/dataSource/appstore.svg';
import GoogleplayIcon from '@/pages/intelligence/assets/svg/dataSource/googleplay.svg';
import { useHistory, getLocale, useDispatch } from 'umi';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { getCountryFlag } from '@/pages/home/_config/countries';
import Databarin from '@/pages/intelligence/assets/svg/dataSource/databarin.svg';
import DatabrainBubbleTip from '@/pages/intelligence/components/TableComponents/components/FirstRow/DatabrainBubbleTip';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import CommonColumns, {
  DetailsCloums,
} from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/CommonCloums';
import CustomTable from '@/pages/intelligence/components/TableComponents/CustomTable';
import { Table, PagingQuery } from 'tea-component';
import { MetricsTableCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/MetricsTableCloums';
import {
  overlapAnalysisSteamTalbeHeaderList,
  getOverlapSteamGamesMetricValueOfCvm,
} from '@intelligence/pages/OverlapAnalysis/MobileGames/utils';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';

const { scrollable } = Table.addons;

const platformIcons = {
  ios: AppstoreIcon,
  android: GoogleplayIcon,
} as any;

const SteamGamesTable = (props: any) => {
  const {
    loading,
    records = [],
    tableTotal = 0,
    pageSortAttr,
    onTableSortChage,
    onTablePagingChange,
    dateType,
    genreSource = '',
    entityType,
  } = props;
  // console.log('Demographics22222222', props);
  const UNIFIED_ID = 'unified_id';
  const APP_ID = 'app_id';
  const dispatch = useDispatch();

  const loadingOrNodata = loading || !records?.length;
  const { formatMessage } = useIntlExtend();
  const locale = getLocale();

  const { tablePageIndex, tablePageSize, currentSortValue, currentSortMetric, currentRatioType } =
    pageSortAttr || {};
  const history = useHistory();
  const defaultPageSize = 100;
  const [pageIndex, setPageIndex] = useState(tablePageIndex || 1);
  const [pageSize, setPageSize] = useState(tablePageSize || defaultPageSize);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    setPageIndex(tablePageIndex);
    setPageSize(tablePageSize);
  }, [tablePageIndex, tablePageSize]);

  const detailCloums = DetailsCloums({
    onClickGame: (cvm: any) => {
      onClickGame(cvm?.[UNIFIED_ID], cvm?.[APP_ID], cvm);
    },
    formatMessage,
  });

  const getMetricCloums = () => {
    const metricCloums: any[] = [];
    overlapAnalysisSteamTalbeHeaderList.forEach((t) => {
      metricCloums.push(
        MetricsTableCloums({
          mauToAvgMau: false,
          renderType: t?.renderType,
          align: t?.align,
          width: t?.width,
          // width_cn: t?.width_cn,
          // orderDataSource: t?.metricValue ?? t?.dataSource,
          dataSource: t?.dataSource, // source === 'ogdb' ? 'databarin' : source,
          icon: (t?.dataSource && t?.dataSource === 'newzoo') ? 'newzoo2databrain' : undefined,
          title: t?.text,
          textContent: t?.info,
          textContentExtra: t?.info_extra,
          key: `${t?.value}`,
          sortMetric: t?.value,
          currentSortValue,
          currentSortKey: `${currentSortMetric}_${currentRatioType}`,
          onSortChage,
          dateType,
          isNoDropdown: t?.isNoDropdown,
          // pageId: pageId,
          getMetricValueOfCvm: getOverlapSteamGamesMetricValueOfCvm,
          formatMessage,
          entityType,
          columnsCenterWidth: Number(t?.width),
          svgTipIsNoMore: t?.isNoMore,
        }),
      );
    });
    return metricCloums;
  };

  useEffect(() => {
    const cloumss = [
      {
        key: 'gametitle',
        header: (
          <div className="dbi-firstRow-flex">
            <div className="dbi-text-id">#</div>
            <div>{formatMessage({ id: 'dbi_top_gametitle' })}</div>
          </div>
        ),
        width: 330,
        fixed: 'left',
        render: (cvm: any) => {
          const platform = Array.isArray(cvm?.platform) ? cvm.platform[0] : cvm?.platform;
          const platformIcon = platformIcons[platform];
          return (
            <FirstRow
              id={cvm?.insideTable ? <></> : cvm?.rank}
              cvm={{
                img: cvm?.cover,
                gametitle: cvm?.name,
                countryIcon: getCountryFlag(cvm?.publisher_addr),
                text: cvm?.publisher,
                isDatabrain: cvm.b_ogdb_data ? Databarin : '',
                databrainIconTip: <DatabrainBubbleTip />,
                frontIcon: platformIcon,
                imgType: 'pc',
              }}
              rihgtClickToJumpHref={getDetailGamePath(cvm?.[UNIFIED_ID], cvm)}
              onClick={() => {
                onClickGame(cvm?.[UNIFIED_ID], cvm?.[APP_ID], cvm);
              }}
            />
          );
        },
      },
      ...getMetricCloums(),
      CommonColumns.ReleaseTimeColumn({ locale, formatMessage }),
      CommonColumns.GenreColumn({ genreSource }),
      detailCloums,
    ];
    setColumns(cloumss);
  }, [JSON.stringify(records), locale]);

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || defaultPageSize);
    onTablePagingChange(e);
  };

  const onSortChage = (e: SortByItemType) => {
    onTableSortChage(e);
  };

  const getDetailGamePath = (gameId: string, cvm: any) => {
    let gameIdValue = gameId;
    let type = 'pc';
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (cvm && cvm?.combined_id && cvm?.combined_id !== '') {
      gameIdValue = cvm?.combined_id;
      type = 'combine';
    }

    return getDetailGamePathCommon({
      entityType: type,
      gameId: gameIdValue,
      tab: 'overlap',
      subTab: '',
    });
  };

  const onClickGame = (unifiedId: string, appId: string, cvm: any) => {
    dispatch({ type: `${DBI_TOPCHARTS}/setOverlapAnalysisAppid`, payload: appId });
    history.push(getDetailGamePath(unifiedId, cvm));
  };

  return (
    <CardSlotV2>
      {/* 公共类名 */}
      <div id="demographics-topcharts-table">
        <CustomTable
          loading={loading}
          records={records}
          className="dbi-mobileGames-table dbi-table-sticky"
          recordKey={APP_ID}
          columns={columns}
          tableTotal={tableTotal}
          pageSize={pageSize}
          pageIndex={pageIndex}
          onPagingChange={(e) => {
            if (onPagingChange instanceof Function) {
              onPagingChange(e);
            }
          }}
          tableAddons={[
            scrollable({
              minWidth: 'auto',
              minHeight: loadingOrNodata ? '158px' : 'auto',
            }),
          ]}
        />
      </div>
    </CardSlotV2>
  );
};

export default SteamGamesTable;
